<template>
  <div class="account-stepper">
    <ul>
      <li
        v-for="(item, index) in stepList"
        :class="{ active: step - 1 == index, disabled: step <= index + 1 }"
        :key="item.title"
      >
        <v-icon color="$success" :class="{ active: step - 2 >= index }">
          mdi-check
        </v-icon>
        <span @click="changeStep(index)">{{ $t(item.titleKey) }}</span>
        <label class="divider">
          <v-icon v-if="index != stepList.length - 1">mdi-chevron-right</v-icon>
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data: () => ({
    stepList: [
      {
        title: '選擇方案',
        titleKey: 'PLAN.WORD.SELECT_PLAN'
      },
      {
        title: '選擇期限',
        titleKey: 'PLAN.WORD.SELECT_DURATION'
      },
      {
        title: '完成訂購',
        titleKey: 'PLAN.WORD.COMPLETE_PURCHASE'
      }
    ]
  }),
  computed: {
    step() {
      return this.$store.state.update.step;
    }
  },
  methods: {
    changeStep(index) {
      if (index == 2 || index + 1 >= this.step) return;
      this.$store.dispatch('update/SETSTEP', index + 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.account-stepper {
  ul {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 0;
    li {
      font-size: 14px;
      color: $neutral400;

      cursor: pointer;
      > i {
        font-size: 16px;
        color: $success;
        margin-top: -3px;
        opacity: 0;
        transition: all 0.2s ease-in-out;

        width: 0;
        height: 0;
        &.active {
          opacity: 1;
          width: 16px;
          height: 16px;
        }
      }

      label {
        padding: 0px 19px;
        i {
          background-color: #353537;
          border-radius: 100px;
          font-size: 1rem;
        }
      }
      &.active {
        cursor: inherit;
        color: $neutral100;
      }
      &.disabled,
      &:nth-last-of-type(1) {
        cursor: inherit;
      }
    }
  }
}
</style>